import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@material-ui/core';
import { CurrencyEnumDto } from '.generated/api';

interface CurrencySelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  required?: boolean;
}

const CurrencySelect: React.FC<CurrencySelectProps> = (props) => {
  const { t } = useTranslation(['translations']);
  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      label={t('organization_page.contract.labels.currency')}
      name="currency"
      {...props}
    >
      {Object.values(CurrencyEnumDto).map((currency) => (
        <MenuItem key={currency} value={currency}>
          {t(`organization_page.contract.currency.${currency.toLowerCase()}`)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CurrencySelect;
